import { UnfilledBookmark as UnfilledBookmark_kojaro } from './UnfilledBookmark.kojaro';
import { UnfilledBookmark as UnfilledBookmark_phosphor } from './UnfilledBookmark.phosphor';
import { UnfilledBookmark as UnfilledBookmark_zoomg } from './UnfilledBookmark.zoomg';
import { UnfilledBookmark as UnfilledBookmark_zoomit } from './UnfilledBookmark.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return UnfilledBookmark_kojaro;

    case 'zoomg':
      return UnfilledBookmark_zoomg;

    case 'phosphor':
      return UnfilledBookmark_phosphor;

    default:
      return UnfilledBookmark_zoomit;
  }
};

export const UnfilledBookmark = IconRenderer();
